let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3iAqS")).then(() => parcelRequire('1neYb'));